import yup from './yup'

export const moderatorFormSchema = yup.object().shape({
  fullName: yup.string().label('Full Name').trimmedRequired('Full name is required')
})
